export default __webpack_public_path__ + "static/media/Hiringimage.f1d467bd.png";